<template>
    <div>
        <div v-if=" !allImpressionsAndClicksEmpty">
            <div class="d-flex flex-row justify-content-center gap-3 mb-8">
                <h1 class="text-center mb-0">{{ __('statistics.online_visibility_title') }}</h1>
                <Tooltip class="w-300px" position="left">
                    <template #trigger>
                        <i class="text-primary cursor-pointer fas fa-info-circle fa-lg"/>
                    </template>
                    <div v-html="infoText"/>
                </Tooltip>
            </div>
            <div v-if="!merchantCenterImpressionsAndClicksEmpty">
                <LineChartWrapper
                    :series="lineChartMappingImpressions"
                    :title="__('statistics.impressions_products')"
                    icon="fas fa-2x fa-chart-bar">
                </LineChartWrapper>

                <LineChartWrapper
                    class="mt-20"
                    :series="lineChartMappingClicks"
                    :title="__('statistics.clicks_products')"
                    icon="fas fa-2x fa-mouse-pointer">
                </LineChartWrapper>
            </div>

            <div v-if="!businessPerformanceEmpty">
                <LineChartWrapper
                    class="mt-20"
                    :series="gmbSeries[GoogleBusinessMetrics.WEBSITE_CLICKS]"
                    :title="__('statistics.' + GoogleBusinessMetrics.WEBSITE_CLICKS)"
                    icon="fas fa-2x fa-mouse-pointer">
                </LineChartWrapper>

                <LineChartWrapper
                    class="mt-20"
                    :series="gmbSeries[GoogleBusinessMetrics.IMPRESSIONS_MOBILE_SEARCH]"
                    :title="__('statistics.' + GoogleBusinessMetrics.IMPRESSIONS_MOBILE_SEARCH)"
                    icon="fas fa-2x fa-chart-bar">
                </LineChartWrapper>

                <LineChartWrapper
                    class="mt-20"
                    :series="gmbSeries[GoogleBusinessMetrics.IMPRESSIONS_DESKTOP_SEARCH]"
                    :title="__('statistics.' + GoogleBusinessMetrics.IMPRESSIONS_DESKTOP_SEARCH)"
                    icon="fas fa-2x fa-chart-bar">
                </LineChartWrapper>

                <LineChartWrapper
                    class="mt-20"
                    :series="gmbSeries[GoogleBusinessMetrics.IMPRESSIONS_MOBILE_MAPS]"
                    :title="__('statistics.' +GoogleBusinessMetrics.IMPRESSIONS_MOBILE_MAPS )"
                    icon="fas fa-2x fa-chart-bar">
                </LineChartWrapper>

                <LineChartWrapper
                    class="mt-20"
                    :series="gmbSeries[GoogleBusinessMetrics.IMPRESSIONS_DESKTOP_MAPS]"
                    :title="__('statistics.' + GoogleBusinessMetrics.IMPRESSIONS_DESKTOP_MAPS)"
                    icon="fas fa-2x fa-chart-bar">
                </LineChartWrapper>

                <LineChartWrapper
                    class="mt-20"
                    :series="gmbSeries[GoogleBusinessMetrics.CALL_CLICKS]"
                    :title="__('statistics.' + GoogleBusinessMetrics.CALL_CLICKS)"
                    icon="fas fa-2x fa-mouse-pointer">
                </LineChartWrapper>
            </div>
            <p v-else class="text-center text-xl mt-4">{{ __('statistics.no_gmb_metrics') }}</p>

        </div>
        <p v-else class="text-center text-xl mt-4">{{ __('statistics.impressions_empty_for_filters') }}</p>
    </div>
</template>

<script>
import LineChartWrapper from '@components/Stats/Components/LineChartWrapper.vue';
import StatisticsLayout from '@layouts/Statistics/StatisticsLayout.vue';
import {GoogleBusinessMetrics} from '@generated/googleBusinessMetrics';
import Tooltip from '@components/Tooltip.vue';

export default {
    layout: StatisticsLayout,

    components: {Tooltip, LineChartWrapper},

    props: {
        mcSeriesImpressionsClicks: Object,
        gmbSeries: Object,
        store: Object,
    },

    computed: {
        GoogleBusinessMetrics() {
            return GoogleBusinessMetrics;
        },

        lineChartMappingImpressions() {
            return Object.entries(this.mcSeriesImpressionsClicks).map(([storeId, storeData]) => {
                return {
                    data: storeData[1].data.map((item) => ({
                        x: item.x,
                        y: item.y,
                    })),
                    name: this.__('statistics.impressions'),
                    total: storeData[1].total,
                };
            });
        },

        lineChartMappingClicks() {
            return Object.entries(this.mcSeriesImpressionsClicks).map(([storeId, storeData]) => {
                return {
                    data: storeData[0].data.map((item) => ({
                            x: item.x,
                            y: item.y,
                        }),
                    ),
                    name: this.__('statistics.clicks'),
                    total: storeData[0].total,
                };
            });
        },

        merchantCenterImpressionsAndClicksEmpty() {
            return Object.values(this.mcSeriesImpressionsClicks).every(storeData => {
                return storeData[0].total === 0 && storeData[1].total === 0;
            });
        },

        businessPerformanceEmpty() {
            return Object.values(this.gmbSeries).every(singleData => {
                return singleData[0].total === 0;
            });
        },

        allImpressionsAndClicksEmpty() {
            return this.businessPerformanceEmpty && this.merchantCenterImpressionsAndClicksEmpty;
        },

        infoText() {
            return this.__('statistics.info_online_visibility');
        }
    },
};
</script>

